import { render, staticRenderFns } from "./editor-submenu.vue?vue&type=template&id=208bfbe0&scoped=true"
import script from "./editor-submenu.vue?vue&type=script&lang=js"
export * from "./editor-submenu.vue?vue&type=script&lang=js"
import style0 from "./editor-submenu.vue?vue&type=style&index=0&id=208bfbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208bfbe0",
  null
  
)

export default component.exports